// Keelis Assets
import logo from "../assest/LogoAndFavicon/keelislogo.png";
import favicon from "../assest/LogoAndFavicon/favicon/keelisfavicon.png";

// Xpert Assets
// import logo from '../assest/LogoAndFavicon/xpertlogo.png'
// import favicon from '../assest/LogoAndFavicon/favicon/xpertfavicon.jpg'

// Cyber Assets
// import logo from '../assest/LogoAndFavicon/cyberlogo.png'
// import favicon from '../assest/LogoAndFavicon/favicon/cyberfavicon.ico'

//Eg Assests
// import logo from "../assest/LogoAndFavicon/evergaurdlogonew.png";
// import favicon from "../assest/LogoAndFavicon/favicon/egfavicon.ico";

// *********************Keelis Assets*******************************************************

//Development
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company:'Keelis',
//  actualname:"Keel Info Solution Private Limited",
//   baseurl:"https://hrmsdev.keelis.in/graphql/",
//   mediaurl:"https://hrmsdev.keelis.in/media",
//   pdfurl:'https://hrmsdev.keelis.in/media/',
//   loginname:'Keelis'
// };

//live

const assets = {
  logo: logo,
  favicon: favicon,
  company: "Keelis",
  actualname: "Keel Info Solution Private Limited",
  baseurl: "https://hrmsdbdemobk.keelis.in/graphql/",
  mediaurl: "https://hrmsdbdemobk.keelis.in/media",
  pdfurl: "https://hrmsdbdemobk.keelis.in/media/",
  loginname: "Keelis",
};

// ******************Xpert Assets**********************************************

// Development
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Xpert',
//  actualname:"Keel Xpert Technologies Private Limited",
//   baseurl:"http://keelxperthrmsbk.keelisdev.in/graphql/",
//   mediaurl:"http://keelxperthrmsbk.keelisdev.in/media",
//   pdfurl:'http://keelxperthrmsbk.keelisdev.in/media/',
//   loginname:'Keel Xpert'
// };

//test

// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Xpert',
//  actualname:"Keel Xpert Technologies Private Limited",
//   baseurl:"http://xperttechbk.keelistest.in/graphql/",
//   mediaurl:"http://xperttechbk.keelistest.in/media",
//   pdfurl:'http://xperttechbk.keelistest.in/media/',
//   loginname:'Keel Xpert'
// };

//live

// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Xpert',
//  actualname:"Keel Xpert Technologies Private Limited",
//   baseurl:"https://xperttechbk.soucient.com/graphql/",
//   mediaurl:"https://xperttechbk.soucient.com/media",
//   pdfurl:'https://xperttechbk.soucient.com/media/',
//   loginname:'Keel Xpert'
// };

// **********************Cyber Assets*****************************************

// Development
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Cyber',
//  actualname:"Keel Cyber Gaurdian Private Limited",
//   baseurl:"http://cyberguardianhrmsdevbk.athithishala.com/graphql/",
//   mediaurl:"http://cyberguardianhrmsdevbk.athithishala.com/media",
//   pdfurl:'http://cyberguardianhrmsdevbk.athithishala.com/media/',
//   loginname:'Cyber Guardian'
// };

//live
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Cyber',
//  actualname:"Keel Cyber Gaurdian Private Limited",
//   baseurl:"https://cyberguardianbk.soucient.com/graphql/",
//   mediaurl:"https://cyberguardianbk.soucient.com/media",
//   pdfurl:'https://cyberguardianbk.soucient.com/media/',
//   loginname:'Cyber Guardian'
// };

//test
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Cyber',
//  actualname:"Keel Cyber Gaurdian Private Limited",
//   baseurl:"http://keelcyberhrmsbk.keelistest.in/graphql/",
//   mediaurl:"http://keelcyberhrmsbk.keelistest.in/media",
//   pdfurl:'http://keelcyberhrmsbk.keelistest.in/media/',
//   loginname:'Cyber Guardian'
// };

// *****************************EG Assets**********************************************

//Development
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGuard Insurance Broking Services Private Limited",
//   baseurl:" https://eghrmsbk.keelisdev.in/graphql/",
//   mediaurl:" https://eghrmsbk.keelisdev.in/media",
//   pdfurl:' https://eghrmsbk.keelisdev.in/media/',
//   loginname:'EverGuard'
// };

//test
// const assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGuard Insurance Broking Services Private Limited",
//   baseurl:" https://eghrmsbk.keelistest.in/graphql/",
//   mediaurl:" https://eghrmsbk.keelistest.in/media",
//   pdfurl:' https://eghrmsbk.keelistest.in/media/',

//   loginname:'EverGuard'
// };

// //test new
// const  assets ={                                                                                                                    assets = {
//   logo:logo,
//   favicon:favicon,
//   company :'Eg',
//   actualname:"EverGaurd Insurance Broking Services Private Limited",
//   baseurl:"http://www.eghrmsnewbk.keelistest.in/graphql/",
//   mediaurl:"http://www.eghrmsnewbk.keelistest.in/media",
//   pdfurl:'http://www.eghrmsnewbk.keelistest.in/media/',

//   loginname:'Ever Guardian'
// };

//Live

// const assets = {
//   logo: logo,
//   favicon: favicon,
//   company: "Eg",
//   actualname: "EverGuard Insurance Broking Services Private Limited",
//   baseurl: "https://hrmsbk.egtech.in/graphql/",
//   mediaurl: "https://hrmsbk.egtech.in/media",
//   pdfurl: "https://hrmsbk.egtech.in/media/",
//   loginname: "EverGuard",
// };

export default assets;
